import React from "react";
import PropTypes from "prop-types";

import { FormattedMessage } from "react-intl";

const IntlText = (props) => {
  return <FormattedMessage id={props.intlId} />;
};

IntlText.propTypes = {
  intlId: PropTypes.string.isRequired,
};

export default IntlText;
